'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.generateKey = generateKey;
exports.pubKey = pubKey;
exports.encrypt = encrypt;
exports.decrypt = decrypt;
exports.sign = sign;
exports.verify = verify;
exports.marshalPubKey = marshalPubKey;
exports.unMarshalPubKey = unMarshalPubKey;
exports.marshalPrivKey = marshalPrivKey;
exports.unMarshalPrivKey = unMarshalPrivKey;

var _asmcryptoAll = require('asmcrypto.js/asmcrypto.all.js');

var asmcrypto = _interopRequireWildcard(_asmcryptoAll);

var _sjcl = require('sjcl');

var _sjcl2 = _interopRequireDefault(_sjcl);

var _asn = require('asn1.js');

var _asn2 = _interopRequireDefault(_asn);

var _bn = require('bn.js');

var _bn2 = _interopRequireDefault(_bn);

var _Convertor = require('../Convertor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function generateKey(bitLength) {
	_sjcl2.default.random.startCollectors();
	console.log(asmcrypto.RSA);
	var seed = _sjcl2.default.codec.bytes.fromBits(_sjcl2.default.random.randomWords(16));
	asmcrypto.random.seed(new Uint8Array(seed));
	return asmcrypto.RSA.generateKey(bitLength, 65537);
}

function pubKey(privKey) {
	return privKey.slice(0, 2);
}

function encrypt(pubKey, data, label) {
	return asmcrypto.RSA_OAEP_SHA256.encrypt(data, pubKey, label);
}

function decrypt(privKey, data, label) {
	return asmcrypto.RSA_OAEP_SHA256.decrypt(data, privKey, label);
}

function sign(privKey, data) {
	return asmcrypto.RSA_PSS_SHA256.sign(data, privKey, 32);
}

function verify(pubKey, signature, data) {
	return asmcrypto.RSA_PSS_SHA256.verify(signature, data, pubKey, 32);
}

// Marshal the key to byte array
function marshalPubKey(key) {
	var pubKey = _asn2.default.define('pubKey', function () {
		this.seq().obj(this.key('m').int(), this.key('E').int());
	});

	return pubKey.encode({
		m: new _bn2.default((0, _Convertor.bytesToHexString)(key[0]), 16),
		E: new _bn2.default((0, _Convertor.bytesToHexString)(key[1]), 16)
	}, 'der');
}

// UnMarshal the key from byte array
function unMarshalPubKey(key) {
	var pubKey = _asn2.default.define('pubKey', function () {
		this.seq().obj(this.key('m').int(), this.key('E').int());
	});

	pubKey = pubKey.decode((0, _Convertor.toBuffer)(key), 'der');

	pubKey = [pubKey.m.toArray(), pubKey.E.toArray()];
	pubKey = pubKey.map(function (x) {
		return new Uint8Array(x);
	});

	return pubKey;
}

// Marshal the key to byte array
function marshalPrivKey(key) {
	var version = 0;

	var privKey = _asn2.default.define('privKey', function () {
		this.seq().obj(this.key('version').int(), this.key('m').int(), this.key('E').int(), this.key('D').int(), this.key('P').int(), this.key('Q').int(), this.key('Dp').int(), this.key('Dq').int(), this.key('Qinv').int());
	});

	privKey = privKey.encode({
		version: version,
		m: new _bn2.default((0, _Convertor.bytesToHexString)(key[0]), 16),
		E: new _bn2.default((0, _Convertor.bytesToHexString)(key[1]), 16),
		D: new _bn2.default((0, _Convertor.bytesToHexString)(key[2]), 16),
		P: new _bn2.default((0, _Convertor.bytesToHexString)(key[3]), 16),
		Q: new _bn2.default((0, _Convertor.bytesToHexString)(key[4]), 16),
		Dp: new _bn2.default((0, _Convertor.bytesToHexString)(key[5]), 16),
		Dq: new _bn2.default((0, _Convertor.bytesToHexString)(key[6]), 16),
		Qinv: new _bn2.default((0, _Convertor.bytesToHexString)(key[7]), 16)
	}, 'der');

	return (0, _Convertor.toUint8Array)(privKey);
}

// UnMarshal the key from byte array
function unMarshalPrivKey(key) {
	var privKey = _asn2.default.define('privKey', function () {
		this.seq().obj(this.key('version').int(), this.key('m').int(), this.key('E').int(), this.key('D').int(), this.key('P').int(), this.key('Q').int(), this.key('Dp').int(), this.key('Dq').int(), this.key('Qinv').int());
	});

	privKey = privKey.decode((0, _Convertor.toBuffer)(key), 'der');

	privKey = [privKey.m.toArray(), privKey.E.toArray(), privKey.D.toArray(), privKey.P.toArray(), privKey.Q.toArray(), privKey.Dp.toArray(), privKey.Dq.toArray(), privKey.Qinv.toArray()];
	privKey = privKey.map(function (x) {
		return new Uint8Array(x);
	});

	return privKey;
}